export const articles = [
  {
    id: 'gongxiang-danche-38gongli',
    title: '他把共享单车骑了38公里带回家，配文：低碳生活从我做起',
    excerpt: '跨了三个区、过了两座桥，只为省下一趟打车钱，结果账单让他当场沉默。',
    category: 'mihuo-xingwei',
    author: '瓜田里的老张',
    date: '2026-09-08',
    readTime: '6 分钟',
    views: 128400,
    likes: 9821,
    comments: 1376,
    cover: 'https://readdy.ai/api/search-image?query=Bold%20flat%20editorial%20illustration%20of%20a%20person%20riding%20a%20shared%20bicycle%20under%20a%20city%20bridge%20at%20dusk%2C%20quirky%20humorous%20scene%2C%20warm%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-01&orientation=landscape',
    tags: ['迷惑行为', '共享单车', '省钱翻车', '魔幻现实'],
    sections: [
      { type: 'p', text: '事情的开头特别朴素：他下班晚了，地铁停运，打车要四十多块。站在路边犹豫了整整两分钟之后，他扫开了一辆共享单车，心里默默算了一笔账——骑车回家不要钱，还能顺便锻炼身体，简直是完美的双赢。' },
      { type: 'h2', text: '一开始，一切都很励志' },
      { type: 'p', text: '前五公里确实是爽的。夜风、路灯、空荡荡的辅路，他甚至在朋友圈发了一条动态：低碳生活从我做起。评论区一片点赞，有人夸他会过日子，有人说这才是当代年轻人的清醒。' },
      { type: 'p', text: '到了第十二公里，导航提示前方连续上坡。他推着车走了两站地，鞋底磨得发热，但仍然安慰自己：省下的都是赚到的。' },
      { type: 'h2', text: '然后账单来了' },
      { type: 'quote', text: '他到家时是凌晨一点半，骑行时长两小时十七分，超出免费时长部分按分钟计费，加上跨区调度费，一共扣了五十八块。' },
      { type: 'p', text: '他盯着手机屏幕沉默了三十秒，然后默默删掉了那条低碳生活的朋友圈。第二天他跟同事复盘这件事，同事只回了一句话：你这不是省钱，你这是花钱买了个故事。' },
      { type: 'p', text: '后来的版本是，这段经历被他写进了部门周报的开场白，标题叫《论决策前一定要看清楚计费规则》。据说那天会议室笑倒了一片，而他也终于承认：有些瓜，是自己种出来的。' },
    ],
  },
  {
    id: 'tuanjian-tiaosan-gai-jianli',
    title: '公司团建强制跳伞，员工落地后第一件事是打开电脑改简历',
    excerpt: 'HR说这是突破自我，员工说这是提前体会了一下自由落体的感觉。',
    category: 'shadiao-xinwen',
    author: '编辑部 小棠',
    date: '2026-09-06',
    readTime: '5 分钟',
    views: 96700,
    likes: 7412,
    comments: 983,
    cover: 'https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20skydiver%20floating%20above%20clouds%20holding%20a%20tiny%20laptop%2C%20satirical%20humorous%20mood%2C%20warm%20cream%20sky%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-02&orientation=landscape',
    tags: ['沙雕新闻', '职场', '团建', '名场面'],
    sections: [
      { type: 'p', text: '这家公司的季度团建通知写得相当热血：“本季度主题——突破边界，勇者先行。”附带的行程表上，第二天上午的栏目写着四个大字：高空跳伞。' },
      { type: 'h2', text: '会议室里的空气凝固了' },
      { type: 'p', text: '通知发出来的那个下午，工位区安静得不正常。有人借口接电话溜出去查资料，有人在群里匿名发起了一个投票：“如果不去跳伞会被记为缺勤吗？”结果九成的人选了“可能会”。' },
      { type: 'p', text: '活动当天，教练反复强调“每个人都会紧张，这很正常”。确实很正常，不正常的是落地之后发生的事——一位同事解开安全扣，走到休息区，打开背包里的笔记本电脑，开始改简历。' },
      { type: 'h2', text: '后来这事有了后续' },
      { type: 'quote', text: 'HR 在复盘会上真诚地表示：“看来我们的团建确实起到了凝聚人心的作用，大家落地之后目标都特别明确。”' },
      { type: 'p', text: '这话倒是没错，只不过方向和大家想的不太一样。据不完全统计，那一次团建之后，三个月内提出离职申请的同事有四个人，理由是“想找一个不需要跳伞的团队”。' },
    ],
  },
  {
    id: 'cai-shichang-qukuailian-jiangjia',
    title: '大爷菜市场用区块链术语讲价，摊主默默掏出二维码：这瓜保真',
    excerpt: '“你这瓜去中心化吗？”“保真，扫码即可验证。”一段讲价，讲出了发布会的气势。',
    category: 'gaoxiao-guaishi',
    author: '吃瓜阿岚',
    date: '2026-09-04',
    readTime: '4 分钟',
    views: 74300,
    likes: 6130,
    comments: 720,
    cover: 'https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20vegetable%20market%20stall%20with%20watermelons%20and%20a%20QR%20code%20sign%2C%20playful%20humorous%20scene%2C%20warm%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-03&orientation=landscape',
    tags: ['搞笑怪事', '菜市场', '梗王', '人间真实'],
    sections: [
      { type: 'p', text: '周末的菜市场照例热闹。一位大爷走到西瓜摊前，先拍了拍瓜，然后开口第一句话就把摊主整不会了：“老板，你这瓜，去中心化吗？”' },
      { type: 'h2', text: '摊主的临场反应堪称教科书' },
      { type: 'p', text: '摊主愣了两秒，随即指着瓜皮上的纹路说：“大爷您看，这纹路天然生成，没有任何人工干预，绝对去中心化。”大爷点点头，又问：“那能溯源吗？”摊主二话不说，从兜里掏出一个二维码牌子，往瓜上一放：“扫码即验证，从哪块地摘的都能查。”' },
      { type: 'p', text: '旁边几个买菜的也跟着乐，有人掏出手机录像，还有人当场给这段对话配了文案：“这是一个属于菜市场的白皮书发布会。”' },
      { type: 'h2', text: '最后成交价更有意思' },
      { type: 'quote', text: '大爷说：“既然是共识定价，那就按我钱包的共识来吧，两块五一斤。”摊主想了想说：“成交，节点已确认。”' },
      { type: 'p', text: '视频传到网上之后，网友的评论比这段对话还精彩。最高赞的一条是：“你看，新技术落地最快的场景永远是菜市场。”' },
    ],
  },
  {
    id: 'cuihun-jiazhuang-chuguo',
    title: '小伙为躲催婚假装出国三年，结果亲戚组团来他家帮忙养猫',
    excerpt: '他以为离开的是催婚现场，没想到留下的是整个家族的运营团队。',
    category: 'lipu-gushi',
    author: '瓜田里的老张',
    date: '2026-09-02',
    readTime: '7 分钟',
    views: 88200,
    likes: 7025,
    comments: 1088,
    cover: 'https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20cozy%20apartment%20with%20a%20cat%20and%20many%20relatives%20crowded%20around%2C%20warm%20humorous%20mood%2C%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-04&orientation=landscape',
    tags: ['离谱故事', '催婚', '养猫', '家庭'],
    sections: [
      { type: 'p', text: '每年过年，他都会准时出现在家族群的“重点关注名单”上。亲戚们的关心方式非常统一：先问工作，再问对象，最后补一句“你看看隔壁家孩子”。第三年，他决定换个打法。' },
      { type: 'h2', text: '他编了一个看起来很真的理由' },
      { type: 'p', text: '他在朋友圈发了一张机场候机厅的照片，配文“工作调动，海外常驻，三年后再见”。从此所有家庭聚会，他都用“时差”和“签证”当挡箭牌。亲戚们的催婚话题，暂时被按下去了。' },
      { type: 'p', text: '唯独有件事他没算到——他养的那只橘猫还在家里。' },
      { type: 'h2', text: '于是剧情开始跑偏' },
      { type: 'p', text: '起初是二姨说“你不在，猫得有人喂吧”，于是每周三来一次；后来是大舅说“光喂不行，得有人铲屎”，于是每周一来一次；再后来姑姑直接把猫砂、猫粮、玩具都备齐了，还建了个群，名字叫“橘宝海外托管小组”。' },
      { type: 'quote', text: '半年后他视频回家，镜头一转，客厅里坐了六个人，正在给猫开“季度健康会议”。'} ,
      { type: 'p', text: '更绝的是，亲戚们在照顾猫的过程里，彼此的感情居然越来越好。等“三年”期限快到时，家里人反倒不太关心他什么时候回来，只关心猫的季节性掉毛问题。' },
      { type: 'p', text: '他最后总结道：我以为我在躲一个话题，没想到我开了一家分公司，还交给了一群最敬业的员工。' },
    ],
  },
  {
    id: 'shitang-ayi-dou-shao-lixue',
    title: '食堂阿姨打菜手抖被做成功力学论文，学生答辩现场加了两道菜',
    excerpt: '一篇关于“抖勺”的严肃研究，让整栋食堂的窗口都学会了公平。',
    category: 'shadiao-xinwen',
    author: '编辑部 小棠',
    date: '2026-08-30',
    readTime: '5 分钟',
    views: 69100,
    likes: 5320,
    comments: 640,
    cover: 'https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20canteen%20serving%20window%20with%20a%20spoon%20and%20a%20tray%2C%20playful%20academic%20humor%2C%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-05&orientation=landscape',
    tags: ['沙雕新闻', '校园', '食堂', '硬核研究'],
    sections: [
      { type: 'p', text: '在一所大学里，有一个流传多年的传说：食堂阿姨的手，会在最后半秒精准地抖一下。不是全抖掉，也不会一点都不抖，而是抖到刚刚好让肉少一块。' },
      { type: 'h2', text: '有人决定认真研究一下' },
      { type: 'p', text: '一位机械工程专业的学生，带着量角器和一个慢动作摄像头，连续两周记录打菜全过程。他把阿姨手腕的摆动拆解成“抬起、停顿、微颤、回摆”四个阶段，还建了模型，算出不同抖动幅度对应的“肉块掉落概率”。' },
      { type: 'p', text: '论文标题起得相当正式：《基于运动学的食堂打菜抖勺现象分析及优化建议》。发到校园论坛之后，浏览量一天破万。' },
      { type: 'h2', text: '答辩那天出了名场面' },
      { type: 'quote', text: '评审老师问他：“你的研究能解决实际问题吗？”他回答：“能，而且已经解决了——我把最后两道菜送给了评委。”' },
      { type: 'p', text: '更离谱的是，学校真的采纳了他的建议，给窗口换了更顺手的勺子和更稳定的托盘。据说从那以后，“抖勺”这个词在食堂里出现的频率明显下降了。' },
    ],
  },
  {
    id: 'fangdong-heyue-jinzhi-emo',
    title: '房东在合同里写“屋内禁止emo”，租客反手交了份情绪管理条例',
    excerpt: '一个想安静的房东，遇上一个文档能力很强的租客，谁也没想到结局是这样。',
    category: 'mihuo-xingwei',
    author: '吃瓜阿岚',
    date: '2026-08-28',
    readTime: '5 分钟',
    views: 58700,
    likes: 4390,
    comments: 512,
    cover: 'https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20rental%20contract%20and%20a%20document%20folder%20on%20a%20desk%2C%20playful%20deadpan%20humor%2C%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-06&orientation=landscape',
    tags: ['迷惑行为', '租房', '文件', '名场面'],
    sections: [
      { type: 'p', text: '看房那天，房东表现得非常和蔼，唯一的要求是“希望住得安静”。签合同的时候，租客在补充条款里发现了一行小字：“屋内禁止 emo，如有情绪请出门化解。”' },
      { type: 'h2', text: '租客决定认真对待这条条款' },
      { type: 'p', text: '三天后，房东收到一份 PDF，标题是《关于“禁止屋内 emo”条款的执行细则（试行）》。里面写得非常专业：定义了 emo 的判定标准、划分了可emo时段与不可emo时段、还附了一张情绪波动曲线图。' },
      { type: 'quote', text: '第八条写着：如遇突发性情绪低落，可申请进入“阳台情绪缓冲区”，单次时长不超过十五分钟。' },
      { type: 'h2', text: '房东的回应也很体面' },
      { type: 'p', text: '房东看完之后，不仅没生气，还回复了一句“细则收到，同意执行”，顺手在合同背面签了字，并且主动提出：如果租客能在季度复查时提交情绪报告，房租可以少一百。' },
      { type: 'p', text: '后来这套房子成了附近最抢手的房源，因为大家都知道，这里的房东和租客都很讲道理，讲道理到有点好笑。' },
    ],
  },
  {
    id: 'ditie-xiedaima-suanming',
    title: '男子地铁上写代码被大爷当成算命，两人为“命运能不能debug”吵了三站',
    excerpt: '一节车厢，两种世界观，谁也没说服谁，但旁边的人都听得很开心。',
    category: 'gaoxiao-guaishi',
    author: '瓜田里的老张',
    date: '2026-08-25',
    readTime: '4 分钟',
    views: 63400,
    likes: 5120,
    comments: 703,
    cover: 'https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20subway%20car%20interior%20with%20a%20laptop%20and%20a%20fortune%20teller%20gesture%2C%20playful%20philosophical%20humor%2C%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-07&orientation=landscape',
    tags: ['搞笑怪事', '地铁', '程序', '哲学'],
    sections: [
      { type: 'p', text: '早高峰的地铁总会发生一些奇怪的事。这一次的主角，是一个抱着笔记本电脑、眉头紧锁的年轻人，屏幕上一行行代码滚得飞快。' },
      { type: 'h2', text: '大爷看了一会儿，忍不住开口了' },
      { type: 'p', text: '“小伙子，你这是在算卦吧？”年轻人抬起头，愣了一下，说：“不是，我在改bug。”大爷点点头，非常认真地说：“那不就是算卦嘛，都是想知道命里到底哪里出了问题。”' },
      { type: 'p', text: '年轻人被这句话整得想笑又笑不出来，于是反问：“那您觉得，命运能 debug 吗？”' },
      { type: 'quote', text: '大爷想了想说：“命是改不了的，但可以打补丁。你看我这把年纪，不也一直在打补丁嘛。”' },
      { type: 'p', text: '两个人从怎么改命，聊到怎么改需求，再到“需求变更到底是不是一种玄学”，一路聊了整整三站。最后大爷下车前还拍了拍年轻人的肩膀：“小伙子，你这个版本，早晚能上线的。”' },
    ],
  },
  {
    id: 'chongwu-dian-zhu-kaifanghui',
    title: '宠物店老板给狗开视频会议，狗全程点头，客户：方案通过了',
    excerpt: '一场看似荒唐的会议，居然真的把项目往前推了一大步。',
    category: 'mohuan-xianshi',
    author: '吃瓜阿岚',
    date: '2026-08-22',
    readTime: '4 分钟',
    views: 51900,
    likes: 4180,
    comments: 466,
    cover: 'https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20dog%20sitting%20in%20front%20of%20a%20video%20call%20screen%2C%20whimsical%20humor%2C%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-08&orientation=landscape',
    tags: ['魔幻现实', '宠物', '会议', '职场'],
    sections: [
      { type: 'p', text: '这位宠物店老板平时生意很忙，唯一的问题是他养的那只柯基特别黏人，只要他一开视频会议，狗就一定要挤进画面。' },
      { type: 'h2', text: '某天，他决定顺其自然' },
      { type: 'p', text: '那天讨论的是一个挺难推进的方案，对方一直没给明确答复。老板讲到一半，柯基照例把脑袋伸进镜头，正好配合着“答不答应”这句话，非常用力地点了两下头。' },
      { type: 'quote', text: '对面沉默了三秒，然后说：“既然你们这边态度这么一致，那就按这个方案来吧。”' },
      { type: 'p', text: '老板当场愣住，但还是飞快地补了一句“好的，合作愉快”。挂断会议之后，他认真地揉了揉狗的头，说：“这个项目，你有一半功劳。”' },
      { type: 'p', text: '后来这成了店里的一个小传统：重要会议之前，先让柯基“表态”。当然，懂的人都懂，这只是给紧张的气氛加点糖。' },
    ],
  },
  {
    id: 'tushuguan-yizi-kegongshi',
    title: '考研学子把图书馆椅子腿刻满公式，图书馆连夜给椅子上锁',
    excerpt: '一把椅子承载了太多知识，最后不得不用最原始的方式保护起来。',
    category: 'qipa-renwu',
    author: '编辑部 小棠',
    date: '2026-08-19',
    readTime: '5 分钟',
    views: 47200,
    likes: 3870,
    comments: 402,
    cover: 'https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20library%20chair%20covered%20in%20tiny%20math%20formulas%20with%20a%20padlock%2C%20playful%20study%20humor%2C%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-09&orientation=landscape',
    tags: ['奇葩人物', '考研', '图书馆', '硬核'],
    sections: [
      { type: 'p', text: '图书馆四楼靠窗的位置，是全校公认的“风水宝地”。据说坐那儿的人都上岸了，于是这块座位常年一位难求。' },
      { type: 'h2', text: '有人在椅子上做了点“标记”' },
      { type: 'p', text: '一位备考的同学，把自己反复记不住的公式一条条刻在了椅子腿上。从泰勒展开到矩阵变换，密密麻麻，堪称一把行走的复习讲义。他还贴心地标了序号，方便每天从不同位置开始背。' },
      { type: 'p', text: '结果这把椅子火了。有人专程来看“武功秘籍”，还有人拍照发论坛，说这是“图书馆最贵的固定资产”。' },
      { type: 'quote', text: '图书馆的回应很直接：当晚就给这把椅子上了一把锁，并在旁边贴了张纸条——“此椅承载知识过多，请勿挪动。”' },
      { type: 'p', text: '后来同学也接受了这个处理，毕竟知识点他已经背下来了。只是每次路过那个座位，他都会忍不住看一眼，像是在跟自己的老朋友打招呼。' },
    ],
  },
  {
    id: 'hunli-xinlang-ppt-kpi',
    title: '婚礼上新郎用PPT汇报爱情KPI，丈母娘要求补充三年财务预测',
    excerpt: '仪式感的最高形态，可能就是把求婚礼办成一场季度经营分析会。',
    category: 'shadiao-xinwen',
    author: '瓜田里的老张',
    date: '2026-08-16',
    readTime: '5 分钟',
    views: 55800,
    likes: 4620,
    comments: 588,
    cover: 'https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20wedding%20scene%20with%20a%20projector%20screen%20and%20charts%2C%20playful%20satirical%20humor%2C%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-10&orientation=landscape',
    tags: ['沙雕新闻', '婚礼', 'PPT', '名场面'],
    sections: [
      { type: 'p', text: '别的新郎在婚礼上放爱情短片，这位新郎放的是自己做的年度汇报。开场第一页写着：“关于爱情项目的阶段性成果与未来规划。”' },
      { type: 'h2', text: '数据非常详实' },
      { type: 'p', text: '他整理了五年来的相处数据：一起看过多少部电影、一起坐过多少次高铁、争吵后平均多久和好，甚至还有一张“情绪波动与和好时长相关性”的折线图。在场宾客从憋笑到放声大笑，只花了半页 PPT 的时间。' },
      { type: 'quote', text: '翻到“未来三年规划”那页时，丈母娘举起手说：“等一下，财务预测呢？我要看现金流。”' },
      { type: 'p', text: '全场爆笑，新郎也不慌，翻到下一页，还真有一张表，标题叫《关于两个人生活的资金安排（含应急储备）》。丈母娘看完点点头，说了句“可以，通过”。' },
      { type: 'p', text: '婚礼结束后，这段视频被亲友们疯狂转发。有人评论说：这场婚礼最大的收获，是让所有人明白，认真规划感情的人，运气都不会太差。' },
    ],
  },
  {
    id: 'waimai-xiaoge-shunshou-jiujia',
    title: '外卖小哥送餐途中顺手劝了个架，平台奖励一辆“年度骑士”电动车',
    excerpt: '他本来只想着别超时，结果顺手把一整条街的秩序都顺了一下。',
    category: 'qipa-renwu',
    author: '吃瓜阿岚',
    date: '2026-08-13',
    readTime: '4 分钟',
    views: 49600,
    likes: 4310,
    comments: 455,
    cover: 'https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20delivery%20rider%20on%20an%20electric%20scooter%20at%20a%20street%20corner%2C%20warm%20heroic%20humor%2C%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-11&orientation=landscape',
    tags: ['奇葩人物', '外卖', '暖新闻', '街坊'],
    sections: [
      { type: 'p', text: '那天中午的单特别多，这位小哥的电瓶车后座挂着六份餐，导航显示下一单还有八分钟超时。路过一个路口时，他看见两位车主因为剐蹭，正站在原地互不相让，后面的车已经排起了长队。' },
      { type: 'h2', text: '他停下车，说了三句话' },
      { type: 'p', text: '第一句是“两位别急”，第二句是“我帮你们拍个照留证”，第三句是“先挪到边上，后面都堵着呢”。整个过程不到两分钟，他拍完照、挪完车，回头看了一眼导航，发现下一单居然还剩六分钟。' },
      { type: 'quote', text: '等他送完餐回到站点，站长说：“你刚才那段被人拍下来发网上了，平台说要表彰你。”' },
      { type: 'p', text: '几天后，平台真的送了一辆新车，车身上印着“年度骑士”。小哥倒是很平静，他说：“我就是不想让大家一直堵着，毕竟我也得赶时间。”' },
      { type: 'p', text: '这条新闻底下，点赞最多的一条评论是：“急的人很多，愿意顺手把事理顺的人不多。”' },
    ],
  },
  {
    id: 'wifi-gaibie-ming-cengwang',
    title: '网友把WiFi改名“隔壁蹭网罚款五十”，第二天收到邻居转账',
    excerpt: '一条网络名，引发了一场堪称教科书级别的邻里互动。',
    category: 'mohuan-xianshi',
    author: '编辑部 小棠',
    date: '2026-08-10',
    readTime: '4 分钟',
    views: 72100,
    likes: 5980,
    comments: 812,
    cover: 'https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20wifi%20router%20on%20a%20windowsill%20with%20a%20phone%20notification%2C%20playful%20neighborhood%20humor%2C%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=800&height=600&seq=gq-art-12&orientation=landscape',
    tags: ['魔幻现实', '邻里', '网络', '神展开'],
    sections: [
      { type: 'p', text: '事情的起因很小：家里的网速一到晚上就变慢。这位网友排查了一圈，判断大概是隔壁在用，于是灵机一动，把 WiFi 名字改成了“隔壁蹭网罚款五十”。' },
      { type: 'h2', text: '第二天，手机响了' },
      { type: 'p', text: '他收到一笔五十元的转账，备注写着：“不好意思，孩子上网课，先交一个月。”他盯着手机看了很久，一时不知道是该退回去，还是该把名字改成“包月优惠”。' },
      { type: 'quote', text: '他最后回了句：“网费不用退了，但密码我改一下，您让孩子白天用。”' },
      { type: 'p', text: '邻居也非常配合，还主动提出可以帮忙代收快递。一来二去，两家人从“隔着一堵墙的陌生人”，变成了会互相留饭的关系。' },
      { type: 'p', text: '后来网友把这段经历发到网上，评论区集体表示：这可能是今年最温暖的一条“罚款通知”。' },
    ],
  },
];